module.exports = __webpack_public_path__ + "img/解决方案背景.67b00c34.png";